export enum AdvancedDatePickerTabsEnum {
    DATE = 'date',
    GRANULARITY = 'granularity',
    TIMEZONE = 'timezone',
    INDEX_GRANULARITY = 'indexGranularity',
    BOA_PERIOD = 'boaPeriod',
}
